module.exports = __webpack_public_path__ + "static/img/seleccion-2.b3dcf58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/seleccion-2.jpg
// module id = RAya
// module chunks = 1